<template>
    <div
        class="story-maker-draggable"
        :class="{ 
            coverDraggable : coverDraggable,
            coverSticker : coverSticker,
            draging: dragOptions.down, 
            selectDisable: dragOptions.down,
            [classCustom]: true
        }"

        :style="{
            top: `${dragOptions.down ? dragOptions.y : position.y}%`,
            left: `${dragOptions.down ? dragOptions.x : position.x}%`,
            zIndex: zIndex,
            transform: `
                translate(-50%, -50%)
                scale(${isSelected ? 1 : resizeOptions.down ? resizeOptions.scale : transform.scale})
                rotate(${isSelected ? 0 : rotateOptions.down ? rotateOptions.rotate : transform.rotate}deg)
                `,
        }"
        @mousedown="startDrag"
    >
        <div v-if="!disableTransform" @mousedown.stop="startRotate" cornerIndex="0" :class="`corner corner-rotate edge-top edge-left rotate-cursor-${(indexImageCursor + 8 % 24 + 24) % 24 + 1}`">
            <div @mousedown.stop="startResize" cornerIndex="0" :class="`corner corner-resize edge-bottom edge-right resize-cursor-${(indexImageCursor + 8 % 12 + 12) % 12 + 1}`"></div>
        </div>
        <div v-if="!disableTransform" @mousedown.stop="startRotate" cornerIndex="1" :class="`corner corner-rotate edge-top edge-right rotate-cursor-${(indexImageCursor + 14 % 24 + 24) % 24 + 1}`">
            <div @mousedown.stop="startResize" cornerIndex="1" :class="`corner corner-resize edge-bottom edge-left resize-cursor-${(indexImageCursor + 14 % 12 + 12) % 12 + 1}`"></div>
        </div>
        <div v-if="!disableTransform" @mousedown.stop="startRotate" cornerIndex="2" :class="`corner corner-rotate edge-bottom edge-right rotate-cursor-${(indexImageCursor + 20 % 24 + 24) % 24 + 1}`">
            <div @mousedown.stop="startResize" cornerIndex="2" :class="`corner corner-resize edge-top edge-left resize-cursor-${(indexImageCursor + 20 % 12 + 12) % 12 + 1}`"></div>
        </div>
        <div v-if="!disableTransform" @mousedown.stop="startRotate" cornerIndex="3" :class="`corner corner-rotate edge-bottom edge-left rotate-cursor-${(indexImageCursor + 2 % 24 + 24) % 24 + 1}`">
            <div @mousedown.stop="startResize" cornerIndex="3" :class="`corner corner-resize edge-top edge-right resize-cursor-${(indexImageCursor + 2 % 12 + 12) % 12 + 1}`"></div>
        </div>

        <!-- <div class="axe axeY" v-if="rotateOptions.down"></div> -->
        <div class="axe axeX"  :style="{ 
            transform: `
                translate(-50%, -50%)
                scale(${1 / (isSelected ? 1 : resizeOptions.down ? resizeOptions.scale : transform.scale)}) 
                `
        }" v-if="rotateOptions.down && Math.abs(rotateOptions.rotate%45) == 0"></div>

        <slot :setCbClick="setCbClick" :isPreventCover="isSelected" :isCover="isSelected"></slot>
    </div>
</template>

<script>
import {calculateDistance, findClosestPoint, calculateAngleABC, normalizeAngle} from "@/utils/Geometry.js";

export default {
    props: {
        position: {
            type: Object,
            required: true
        },
        transform: {
            type: Object,
            required: true
        },
        disableTransform: {
            type: Boolean,
            default: false,
        },
        disableMove: {
            type: Boolean,
            default: false,
        },

        disableIncreaseZIndex: {
            type: Boolean,
            default: false,
        },

        
        disableDelete: {
            type: Boolean,
            default: false,
        },
        
        classCustom: {
            type: String,
            default: '',
        },
        
        zIndex: {
            type: Number,
            default: 1,
        },

        trashIsHover: {
            type: Boolean,
            default: false,
        },

        isSelected: {
            type: Boolean,
            default: false,
        }

       
    },

    data() {
        return {
            timeout: null,
            coverDraggable: false,
            coverSticker: false,

            cbClick: null,
            
            dragOptions: {
                x:0,
                y:0,
                down: false,
                startX: 0,
                startY: 0,
                top: 0,
                left: 0,
                parent: null,
                multiplier: {
                    x: 1,
                    y: 1,
                },
                zone: {
                    min : {x: 0, y: 0},
                    max : {x: 0, y: 0},
                },
                timeStart: null
            },

            resizeOptions: {
                down: false,
                stickerNode: null,
                stickerPosition: {x: 0, y: 0},
                stickerDiagonalDistance : 0,
                scale: null,
                cornerIndex: 0
            },
            
            rotateOptions: {
                down: false,
                stickerNode: null,
                stickerPosition: {x: 0, y: 0},
                rotate: null,
                cornerIndex: 0,
                startCursor: {x: 0, y: 0},
            },

         
        };
    },
    methods: {
        setCbClick(cb) {
            this.cbClick = cb;
        },
        ///// Drag /////
        startDrag(e) {
            e.stopPropagation() 
            console.log('startDrag',this.$el, e.target, this.classCustom)
            if (this.isSelected) return
            console.log('startDrag2')
            if (!this.disableIncreaseZIndex) this.$emit('increaseZIndex')

            if (!this.disableMove) {
                this.$emit('setDragState', true)
                this.dragOptions.down = true
                this.dragOptions.timeStart = Date.now()
                this.dragOptions.parent = e.target.offsetParent.closest(".overflow")
                
                const parentRect = this.dragOptions.parent.getBoundingClientRect();

                this.dragOptions.multiplier = {
                    x: 100 / parentRect.width,
                    y: 100 / parentRect.height,
                }

                this.dragOptions.zone = {
                    min : {x: parentRect.x, y: parentRect.y},
                    max : {x: parentRect.x+parentRect.width, y: parentRect.y + parentRect.height},
                },

                this.dragOptions.y = this.position.y
                this.dragOptions.x = this.position.x
                
                this.dragOptions.top = this.position.y
                this.dragOptions.left = this.position.x
                this.dragOptions.startX = e.clientX
                this.dragOptions.startY = e.clientY
        
                document.addEventListener('mousemove', this.onDrag);
            }
            document.addEventListener('mouseup', this.stopDrag);
        },

        onDrag(e) {

            if (!this.dragOptions.down) return;
            this.$emit("setShowAxe",'index', this.zIndex - 1)
            window.requestAnimationFrame(() => {
                if (e.clientX > this.dragOptions.zone.min.x && e.clientX < this.dragOptions.zone.max.x) {
                    this.dragOptions.x =  this.dragOptions.left + (e.clientX - this.dragOptions.startX) * this.dragOptions.multiplier.x;
                    if (this.dragOptions.x > 49 && this.dragOptions.x < 51) {
                        this.dragOptions.x = 50
                        this.$emit("setShowAxe",'y',true)
                    }else{
                        this.$emit("setShowAxe",'y',false)
                    }
                }
                    
                if (e.clientY > this.dragOptions.zone.min.y && e.clientY < this.dragOptions.zone.max.y) {
                    this.dragOptions.y = this.dragOptions.top + (e.clientY - this.dragOptions.startY) * this.dragOptions.multiplier.y;
                    if (this.dragOptions.y > 49.6 && this.dragOptions.y < 50.4) {
                        this.dragOptions.y = 50
                        this.$emit("setShowAxe",'x',true)
                    }else{
                        this.$emit("setShowAxe",'x',false)
                    }
                }

            });
        },

        stopDrag() {
            if (!this.dragOptions.down) return

            if (Date.now() - this.dragOptions.timeStart < 150) {
                //click
                this.$emit('click')
                if (this.cbClick) this.cbClick()
            }else{

                //drag
                this.$set(this.position, 'x', this.dragOptions.x);
                this.$set(this.position, 'y', this.dragOptions.y);
                this.$emit('saveFormData')
                if (this.trashIsHover && !this.disableDelete) this.$emit('deleteSticker')
            }

            this.$set(this.dragOptions, 'down', false)
            this.$emit('setDragState', false)
            this.$emit("setShowAxe",'x',false)
            this.$emit("setShowAxe",'y',false)
            document.removeEventListener('mousemove', this.onDrag);
            document.removeEventListener('mouseup', this.stopDrag);
        },
        ///// Resize /////
        startResize(e) {
            if (this.cover || this.preventCover) return
            if (!this.disableIncreaseZIndex) this.$emit('increaseZIndex')
            this.resizeOptions.down = true
            this.resizeOptions.scale = this.transform.scale

            this.resizeOptions.stickerNode = e.target.offsetParent.closest(".story-maker-draggable")
            const parentRect = this.resizeOptions.stickerNode.getBoundingClientRect();

            this.resizeOptions.stickerPosition = {
                x: parentRect.x + parentRect.width/2,
                y: parentRect.y + parentRect.height/2
            }
            

            this.resizeOptions.stickerDiagonalDistance = calculateDistance(this.resizeOptions.stickerPosition, {x: e.clientX, y: e.clientY})
       
            this.resizeOptions.cornerIndex = parseInt(e.target.getAttribute("cornerIndex"))

            document.addEventListener('mousemove', this.onResize);
            document.addEventListener('mouseup', this.stopResize);     
        },

        onResize(e) {
            if (!this.resizeOptions.down) return;
            window.requestAnimationFrame(() => {
                const coords = {
                    x: e.clientX,
                    y: e.clientY
                }
                this.resizeOptions.scale = this.transform.scale * calculateDistance(this.resizeOptions.stickerPosition, coords) / this.resizeOptions.stickerDiagonalDistance
            });
        },

        stopResize() {
            if (!this.resizeOptions.down) return
            this.$set(this.resizeOptions, 'down', false)
            this.$set(this.transform, 'scale', this.resizeOptions.scale)
            this.$emit('setStoryMakerCursor','')
            document.removeEventListener('mousemove', this.onResize);
            document.removeEventListener('mouseup', this.stopResize);
            this.$emit('saveFormData')
        },
        ///// Rotation /////
        startRotate(e) {
            if (this.cover || this.preventCover) return
            if (!this.disableIncreaseZIndex) this.$emit('increaseZIndex')
            this.rotateOptions.down = true
            this.rotateOptions.rotate = this.transform.rotate

            this.rotateOptions.stickerNode = e.target.offsetParent.closest(".story-maker-draggable")
            const parentRect = this.rotateOptions.stickerNode.getBoundingClientRect();

            this.rotateOptions.stickerPosition = {
                x: parentRect.x + parentRect.width/2,
                y: parentRect.y + parentRect.height/2
            }

            this.rotateOptions.startCursor = {
                x: e.clientX,
                y: e.clientY
            } 

            this.rotateOptions.cornerIndex = parseInt(e.target.getAttribute("cornerIndex"))
            
            document.addEventListener('mousemove', this.onRotate);
            document.addEventListener('mouseup', this.stopRotate);     
        },

        onRotate(e) {
            if (!this.rotateOptions.down) return;
            window.requestAnimationFrame(() => {
                const coords = {
                    x: e.clientX,
                    y: e.clientY
                }
                this.rotateOptions.rotate = normalizeAngle(this.transform.rotate + calculateAngleABC(this.rotateOptions.startCursor , this.rotateOptions.stickerPosition, coords))
               
                if (Math.abs(this.rotateOptions.rotate%45) < 1 || Math.abs(this.rotateOptions.rotate%45) > 44) {
                    this.rotateOptions.rotate = Math.round(this.rotateOptions.rotate / 45) * 45;
                }
            });
        },

        stopRotate() {
            if (!this.rotateOptions.down) return
            this.$set(this.rotateOptions, 'down', false)
            this.$set(this.transform, 'rotate', this.rotateOptions.rotate)
            this.$emit('setStoryMakerCursor','')
            document.removeEventListener('mousemove', this.onRotate);
            document.removeEventListener('mouseup', this.stopRotate);
            this.$emit('saveFormData')
        },

        selected() {
            if (!this.isSelected) return this.$emit('select')
            if (this.timeout) clearTimeout(this.timeout)

            this.coverDraggable = true;
            this.timeout = setTimeout(() => {
                this.coverSticker = true;
            }, 20); 
        },

        unselected() {
            if (this.isSelected) return this.$emit('unselect')
            if (this.timeout) clearTimeout(this.timeout)

            this.coverDraggable = false;

            this.$nextTick(()=> {
                const stickerEl = this.$el.querySelector('.sticker')
                if (stickerEl) {
                    stickerEl.style.transform = `translate(-50%, -50%) scale(${this.transform.scale}) rotate(${this.transform.rotate}deg)`
                    stickerEl.style.top = `${this.position.y}%`,
                    stickerEl.style.left = `${this.position.x}%`
                } 

                this.timeout = setTimeout(() => {
                    if (stickerEl) {
                        stickerEl.style.transform = ``
                        stickerEl.style.top = ``,
                        stickerEl.style.left = ``
                    } 

                    this.coverSticker = false;
                }, 200); 
            })
                   
           
        },
    },

    computed: {
        indexImageCursor() {
            const index = Math.floor((((this.rotateOptions.down ? this.rotateOptions.rotate : this.transform.rotate) + 7.5) % 360 + 360) % 360 / 15) + 1

            if (this.rotateOptions.down) {
                const offsetImage = (8 + 6*(this.rotateOptions.cornerIndex))
                this.$emit('setStoryMakerCursor', `rotate-cursor-${(index + offsetImage % 24 + 24) % 24 + 1}`)
                                                   
            }else if (this.resizeOptions.down) {
                const offsetImage = (8 + 6*(this.resizeOptions.cornerIndex))
                this.$emit('setStoryMakerCursor', `resize-cursor-${((index + offsetImage) % 12 + 12) % 12 + 1}`)
            }                                                         
           
            return index
        },
        
    },
    beforeDestroy() {
        this.$emit('setStoryMakerCursor','')
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('mousemove', this.onResize);
        document.removeEventListener('mouseup', this.stopResize);
        document.removeEventListener('mousemove', this.onRotate);
        document.removeEventListener('mouseup', this.stopRotate);

        if (this.dragOptions.down) this.$emit('setDragState', false)
        this.$emit("setShowAxe",'y',false)
        this.$emit("setShowAxe",'x',false)
    },

    watch: {
        isSelected: {
            handler(value, oldValue) {
                if (value) {
                    this.selected()
                }else if(oldValue){
                   this.unselected()
                } 
            },
            immediate: true
        },
    }
};
</script>
